import { toast } from "react-toastify";
import { GET, POST, PUT, DEL, MULTIPART_POST, MULTIPART_PUT } from "config/api.config";
import { USER_COMPANY } from "config/apiEndPoint";

/** GET `user/company/metadata?companyId=` (optional query). */
export const fetchCompanyUserTableAndFilterSchema = async (companyId) => {
    try {
        const q = companyId ? `?companyId=${encodeURIComponent(String(companyId))}` : "";
        const response = await GET(`${USER_COMPANY.METADATA}${q}`);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** POST `user/company/filter` — list (include `companyId` in body). */
export const submitCompanyUserFilterData = async (data = {}) => {
    try {
        const response = await POST(USER_COMPANY.FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** GET `user/company/{userId}` — detail for add/edit form. */
export const getCompanyUserById = async (userId = "") => {
    const raw = String(userId ?? "").trim();
    if (!raw) {
        toast.error("User id is required");
        return undefined;
    }
    try {
        const response = await GET(USER_COMPANY.BY_ID(raw));
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** POST `user/company/{companyId}/user` — create (JSON or multipart when `data` is FormData). */
export const createCompanyUser = async (companyId = "", data) => {
    const companyIdValue = String(companyId ?? "").trim();
    if (!companyIdValue) {
        toast.error("Company id is required");
        return undefined;
    }
    try {
        const url = USER_COMPANY.CREATE(companyIdValue);
        if (data instanceof FormData) {
            return await MULTIPART_POST(url, data);
        }
        return await POST(url, data);
    } catch (error) {
        toast.error(error?.message);
    }
};

/** PUT `user/company/{companyId}/user/{userId}` — update (JSON or multipart). */
export const updateCompanyUser = async (companyId = "", userId = "", data) => {
    const c = String(companyId ?? "").trim();
    const u = String(userId ?? "").trim();
    if (!c || !u) {
        toast.error("Company id and user id are required");
        return undefined;
    }
    try {
        const url = USER_COMPANY.UPDATE(c, u);
        if (data instanceof FormData) {
            return await MULTIPART_PUT(url, data);
        }
        return await PUT(url, data);
    } catch (error) {
        toast.error(error?.message);
    }
};

/** GET `user/company/user-type-options` — user type dropdown (company user add/edit). */
export const getCompanyUserTypeOptions = async () => {
    try {
        const response = await GET(USER_COMPANY.USER_TYPE_OPTIONS);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** GET `user/company/{companyId}/clients` — assignable clients (add/edit company user). */
export const getCompanyUserClients = async (data = {}) => {
    try {
        const url = data?.companyId
            ? `${USER_COMPANY.CLIENTS}/${data?.companyId}/clients`
            : `${USER_COMPANY.CLIENTS}/clients`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** DELETE `user/{userId}/company/{companyId}` */
export const deleteCompanyUser = async (userId = "", companyId = "") => {
    const u = String(userId ?? "").trim();
    const c = String(companyId ?? "").trim();
    if (!u || !c) {
        toast.error("User id and company id are required");
        return undefined;
    }
    try {
        const response = await DEL(USER_COMPANY.DELETE(u, c));
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
